import { baixarAnexo, buscar, enviar, enviarArquivo } from '@/portal/api';
import type {
  AnexoDoPortal,
  ArtigoDoPortal,
  CatalogoDoPortal,
  ChamadoDoPortal,
  ComentarioDoPortal,
  DetalheDeChamadoDoPortal,
  ErroConhecidoDoPortal,
  PaginaDoPortal,
  ResumoDeArtigoDoPortal,
} from '@/portal/tipos';

/** As chamadas do portal, em um lugar só. Nenhuma delas sai de `/portal`. */

export const catalogo = () => buscar<CatalogoDoPortal>('/catalog');

export interface FiltroDeChamados {
  situacao?: 'abertos' | 'resolvidos' | 'todos';
  ordem?: 'recentes' | 'antigos' | 'prazo';
  cursor?: string;
}

export function listarChamados(filtro: FiltroDeChamados = {}) {
  const busca = new URLSearchParams();
  if (filtro.situacao) busca.set('situacao', filtro.situacao);
  if (filtro.ordem) busca.set('ordem', filtro.ordem);
  if (filtro.cursor) busca.set('cursor', filtro.cursor);
  const sufixo = busca.toString();
  return buscar<PaginaDoPortal<ChamadoDoPortal>>(`/tickets${sufixo ? `?${sufixo}` : ''}`);
}

export const chamado = (id: string) => buscar<DetalheDeChamadoDoPortal>(`/tickets/${id}`);

export const comentarios = (id: string) =>
  buscar<ComentarioDoPortal[]>(`/tickets/${id}/comments`);

export const anexos = (id: string) => buscar<AnexoDoPortal[]>(`/tickets/${id}/attachments`);

export interface NovoChamado {
  servicoId: string;
  assunto: string;
  descricaoHtml?: string;
  tipo?: 'INCIDENT' | 'REQUEST';
  urgencia?: 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL';
}

export const abrirChamado = (novo: NovoChamado) =>
  enviar<DetalheDeChamadoDoPortal>('/tickets', novo);

export const comentar = (id: string, corpoHtml: string) =>
  enviar<ComentarioDoPortal>(`/tickets/${id}/comments`, { corpoHtml });

export const anexarArquivo = (id: string, arquivo: File) =>
  enviarArquivo<AnexoDoPortal>(`/tickets/${id}/attachments`, arquivo);

export const baixarAnexoDoChamado = (id: string, anexoId: string, nome: string) =>
  baixarAnexo(`/tickets/${id}/attachments/${anexoId}/content`, nome);

export const errosConhecidos = (q?: string) =>
  buscar<{ items: ErroConhecidoDoPortal[] }>(
    `/known-errors${q ? `?q=${encodeURIComponent(q)}` : ''}`,
  );

export const artigos = (q?: string) =>
  buscar<{ items: ResumoDeArtigoDoPortal[] }>(
    `/knowledge${q ? `?q=${encodeURIComponent(q)}` : ''}`,
  );

export const artigo = (id: string) => buscar<ArtigoDoPortal>(`/knowledge/${id}`);
